__turbopack_context__.v({
  "card": "kWbKeq_card",
  "image": "kWbKeq_image",
});
